import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { addLabTest, clearError, clearSuccess } from '../../../../redux/Slices/authSlice';
import { applyFieldFilter } from '../../../../shared/utils.js/fieldValidation';


// add lab tests component
const AddLabTests = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoading } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    name_ar: '',
    name_en: '',
    is_active: true,
  });

  useEffect(() => {
    return () => {
      dispatch(clearError());
      dispatch(clearSuccess());
    };
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const finalValue = type === 'checkbox' ? checked : applyFieldFilter(name, value);
    setFormData(prev => ({ ...prev, [name]: finalValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name_ar || !formData.name_en) {
      toast.error('الرجاء تعبئة جميع الحقول المطلوبة');
      return;
    }

    try {
      await dispatch(addLabTest(formData)).unwrap();
      dispatch(clearError());
      navigate('/lab-tests');
    } catch (error) {
      toast.error(error || 'حدث خطأ أثناء إضافة الاختبار', { rtl: true });
    }
  };

  const handleGoBack = () => {
    dispatch(clearError());
    dispatch(clearSuccess());
    navigate(-1);
  };

  return (
    <div style={{ padding: '30px', backgroundColor: '#14263b', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
      <div style={{ width: '100%', maxWidth: '700px', backgroundColor: '#1b3350', borderRadius: '12px', padding: '24px', border: '1px solid #333' }}>
        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1 style={{ margin: 0, fontSize: '22px' }}>إضافة اختبار </h1>
          <button
            type="button"
            onClick={handleGoBack}
            style={{
              backgroundColor: 'transparent',
              color: '#fff',
              border: '1px solid #444',
              borderRadius: '6px',
              padding: '8px 16px',
              cursor: 'pointer',
            }}
          >
            رجوع
          </button>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', color: '#ccc' }}>الاسم بالعربية</label>
            <input
              type="text"
              name="name_ar"
              value={formData.name_ar}
              onChange={handleChange}
              placeholder="مثال: اختبار جديد"
              style={inputStyle}
            />
          </div>
          <div>
            <label style={{ display: 'block', marginBottom: '6px', color: '#ccc' }}>الاسم بالإنجليزية</label>
            <input
              type="text"
              name="name_en"
              value={formData.name_en}
              onChange={handleChange}
              placeholder="Example: New Test"
              style={inputStyle}
            />
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#ccc' }}>
            <input type="checkbox" name="is_active" checked={formData.is_active} onChange={handleChange} />
            نشط
          </label>

          <button
            type="submit"
            disabled={isLoading}
            style={{
              backgroundColor: '#1f5ff1',
              color: 'white',
              border: 'none',
              padding: '12px',
              borderRadius: '8px',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              fontWeight: 'bold',
              opacity: isLoading ? 0.7 : 1,
            }}
          >
            {isLoading ? 'جارٍ الحفظ...' : 'حفظ الاختبار'}
          </button>
        </form>
      </div>
    </div>
  );
};

const inputStyle = {
  width: '100%',
  padding: '12px',
  backgroundColor: '#1a1f2e',
  border: '1px solid #333',
  borderRadius: '8px',
  color: 'white',
  fontSize: '14px',
  boxSizing: 'border-box',
};

export default AddLabTests;

